document.addEventListener("DOMContentLoaded", () => {

    if (typeof gsap === "undefined") return;
    if (typeof ScrollTrigger === "undefined") return;

    gsap.registerPlugin(ScrollTrigger);

    const isMobile = window.matchMedia("(max-width:768px)").matches;

       
/* =====================================================
   INFLUENCER RAIL
===================================================== */

const influencerRail = document.querySelector(".bam-influencer");

if (influencerRail && !isMobile) {

    const track = document.getElementById("bamInfluencerTrack");

    const fill = document.getElementById("bamInfluencerFill");

    const counter = document.getElementById("bamInfluencerStep");

    const cards = track.querySelectorAll(".bam-influencer-card");

    const totalCards = cards.length;

    gsap.to(track, {

        x: () => {

            return -(track.scrollWidth - window.innerWidth);

        },

        ease: "none",

        scrollTrigger: {

            trigger: influencerRail,

            start: "top top",

            end: () => "+=" + (track.scrollWidth),

            scrub: 1.5,

            pin: ".bam-influencer__viewport",

            pinSpacing: false,

            anticipatePin: 1,

            invalidateOnRefresh: true,

            onUpdate: self => {

                if (fill) {

                    fill.style.width = (self.progress * 100) + "%";

                }

                if (counter) {

                    let current = Math.floor(self.progress * totalCards) + 1;

                    current = Math.min(current, totalCards);

                    counter.textContent =

                        String(current).padStart(2, "0") +

                        "/" +

                        String(totalCards).padStart(2, "0");

                }

            }

        }

    });

}

    /* =====================================================
       HERO
    ===================================================== */

    if (document.querySelector(".bam-hero")) {

        gsap.timeline({

            scrollTrigger: {

                trigger: ".bam-hero",

                start: "top top",

                end: "bottom bottom",

                scrub: 1.5,

                pin: ".bam-hero__stage",

                pinSpacing: false,

                anticipatePin: 1

            }

        })

        .fromTo(

            ".bam-hero__logo",

            {
                scale: isMobile ? 1.6 : 3
            },

            {
                scale: 1,
                opacity: isMobile ? .2 : .1,
                ease: "none",
                duration: 1
            },

            0

        )

        .to(

            ".bam-hero__tag",

            {
                opacity: 1,
                ease: "none",
                duration: .5
            },

            .5

        );

    }



    /* =====================================================
       MARQUEE
    ===================================================== */

    const marquee = document.getElementById("bamMarqueeTrack");

    if (marquee) {

        while (marquee.scrollWidth < window.innerWidth * 3) {

            [...marquee.children].forEach(el => {

                marquee.appendChild(el.cloneNode(true));

            });

        }

        let x = 0;

        const loopWidth = marquee.scrollWidth / 2;

        gsap.ticker.add(() => {

            x -= 1.4;

            if (x <= -loopWidth) {

                x += loopWidth;

            }

            marquee.style.transform = `translate3d(${x}px,0,0)`;

        });

    }



    /* =====================================================
       PRODUCT RAIL
    ===================================================== */

    const rail = document.querySelector(".bam-rail");

    if (rail && !isMobile) {

        const track = document.getElementById("bamRailTrack");

        const fill = document.getElementById("bamRailFill");

        const counter = document.getElementById("bamRailStep");

        const cards = track.querySelectorAll(".bam-card");

        const totalCards = cards.length;

        gsap.to(track, {

            x: () => {

                return -(track.scrollWidth - window.innerWidth);

            },

            ease: "none",

            scrollTrigger: {

                trigger: rail,

                start: "top top",

                end: () => "+=" + (track.scrollWidth),

                scrub: 1.5,

                pin: ".bam-rail__viewport",

                pinSpacing: false,

                anticipatePin: 1,

                invalidateOnRefresh: true,

                onUpdate: self => {

                    if (fill) {

                        fill.style.width = (self.progress * 100) + "%";

                    }

                    if (counter) {

                        let current = Math.floor(self.progress * totalCards) + 1;

                        current = Math.min(current, totalCards);

                        counter.textContent =

                            String(current).padStart(2, "0") +

                            "/" +

                            String(totalCards).padStart(2, "0");

                    }

                }

            }

        });

    }



    /* =====================================================
       REFRESH
    ===================================================== */

    window.addEventListener("resize", () => {

        ScrollTrigger.refresh();

    });

});


/* ===========================
   IMPACT
=========================== */

const impact = document.querySelector(".bam-impact");

if (impact) {

    gsap.to("#bamImpactCard", {

        scale:1,

        borderRadius:0,

        ease:"none",

     scrollTrigger:{

    trigger:rail,

    start:"top top",

    end:()=>"+="+track.scrollWidth,

    scrub:1.5,

    pin:".bam-rail__viewport",

    pinSpacing:true,

    anticipatePin:1,

        }

    });

}

